import { httpClient } from "../http/httpClient";
import {
  requestWithdrawBody,
  requestWithdrawResponse,
} from "../transactionService/requestWithdraw";

export interface CreateCrefazTransactionBody extends requestWithdrawBody {
  linkName: string;
}

export async function createCrefazTransaction(
  body: CreateCrefazTransactionBody,
): Promise<requestWithdrawResponse> {
  const {
    linkName,
    type,
    value,
    customerId,
    propostaId,
    prestacao,
    Prazo,
    adicionais,
  } = body;

  const { data } = await httpClient
    .post<requestWithdrawResponse>(`/self-hire/${linkName}/transaction`, {
      type,
      value,
      customerId,
      providerData: {
        propostaId,
        prestacao,
        Prazo,
        adicionais,
      },
    })
    .catch((err) => {
      throw err?.response?.data || err;
    });

  return data;
}
